import React, { useEffect, useState } from "react";
import profesoresData from "../data/profesores.json";
import ProfesorCard from "components/ProfesorCard";

const Teachers = () => {
  const [profesores, setProfesores] = useState([]);
  useEffect(() => {
    setProfesores(profesoresData);
  }, []);
  return (
    <section className="bg-secundario">
      <div className="bg-primario flex flex-col">
        <div className="m-40 h-[30vh] flex flex-col justify-end items-center">
          <h1 className="text-9xl font-Bebas font-bold text-secundario">
            Profesores Brighton
          </h1>
        </div>
      </div>
      <div className="p-40">
        <p className="text-3xl text-primario w-3/4 mx-auto text-center">
          Conoce a nuestro equipo de docentes que hacen posible la experiencia
          educativa en <strong>Brighton English Center</strong>.
        </p>
      </div>
      <div className="grid grid-cols-4 gap-10 w-3/4 mx-auto pb-40">
        {profesores.map((profe) => (
          <ProfesorCard key={profe.id} profesor={profe} />
        ))}
        {/* {profesoresData.map((profes, index) => (
          <ProfesorCard key={index} profesor={profes} />
        ))} */}
      </div>
    </section>
  );
};

export default Teachers;
